import React from 'react';

import { Text } from 'components/DataDisplay';
import { Modal } from 'components/Feedback';
import { FormSection } from 'components/FormSection';
import { Button, MultipleSelect, Select, TextField } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';

const ErrorState = {
  shopGroupIdError: false,
  cpmError: false,
  mobileCpmError: false,
  activableMediaError: false,
  formatsError: false
};
export const ModalForm = props => {
  const { config, onValidate, onClose, domainGroupId } = props;
  const { medias, shopGroups, mediaFormats, selected, otherConfigs } = config;

  const initialState = {
    shopGroupId: selected?.shopGroupId || '',
    formats: selected?.formats || [],
    activableMedia: selected?.activableMedia || '',
    cpm: selected?.cpm || '',
    mobileCpm: selected?.mobileCpm || ''
  };

  const [
    { shopGroupId, formats, activableMedia, cpm, mobileCpm },
    setState
  ] = React.useState(initialState);
  const [
    {
      shopGroupIdError,
      cpmError,
      mobileCpmError,
      activableMediaError,
      formatsError
    },
    setError
  ] = React.useState(ErrorState);

  const toggleError = (key, state) => {
    setError(prevState => ({
      ...prevState,
      [`${key}Error`]: state
    }));
  };

  const handleChange = itemKey => value => {
    const text = typeof value === 'string' ? value.trim() : value;
    toggleError(itemKey, !text);
    if (itemKey === 'groupKey') {
      toggleError(
        'groupKey',
        shopGroups.some(group => group.key === value)
      );
    }
    setState(prevState => {
      const states = { ...prevState };
      states[itemKey] = text;
      return states;
    });
  };

  const onNext = async () => {
    let error = false;

    if (!shopGroupId) {
      toggleError('shopGroupId', true);
      error = true;
    }
    if (cpm === '') {
      toggleError('cpm', true);
      error = true;
    }
    if (mobileCpm === '') {
      toggleError('mobileCpm', true);
      error = true;
    }

    if (!formats.length) {
      toggleError('formats', true);
      error = true;
    }

    if (!error) {
      const datas = {
        shopGroupId: shopGroupId !== domainGroupId ? shopGroupId : '',
        formats,
        activableMedia,
        cpm,
        mobileCpm
      };
      await onValidate(datas);
      onClose();
    }
  };

  const getActions = () => {
    const disabled = !shopGroupId;
    return (
      <Container>
        <Row spacing={1}>
          <Item xs justify="flex-end">
            <Button
              variant="contained"
              size="medium"
              disabled={disabled}
              widthSize="medium"
              onClick={onNext}
            >
              Valider
            </Button>
          </Item>
        </Row>
      </Container>
    );
  };

  const formatInOtherConfig = otherConfigs.some(
    item =>
      item.shopGroupId === shopGroupId &&
      item.activableMedia === activableMedia &&
      item.formats.some(format => formats.includes(format))
  );
  return (
    <Modal open actions={getActions()} {...props}>
      <FormSection
        title={`${selected ? 'Modifier' : 'Ajouter'} une configuration`}
        xs={3}
      >
        <Row spacing={0} justify="flex-start">
          <Item xs={6} justify="flex-start">
            <Row spacing={0} justify="flex-start">
              <Item xs={11} justify="flex-start">
                <Select
                  title="Configuration"
                  small
                  required
                  options={shopGroups}
                  value={shopGroupId}
                  onChange={handleChange('shopGroupId')}
                  disabled={selected?.id}
                  error={shopGroupIdError}
                />
              </Item>
            </Row>
          </Item>
        </Row>
        <Row spacing={0} justify="flex-start">
          <Item xs={6} justify="flex-start">
            <Row spacing={0} justify="flex-start">
              <Item xs={11} justify="flex-start">
                <Select
                  title="Média"
                  small
                  required
                  options={medias}
                  value={activableMedia}
                  onChange={handleChange('activableMedia')}
                  disabled={selected?.id}
                  error={activableMediaError}
                />
              </Item>
            </Row>
          </Item>
          <Item xs={6} justify="flex-start">
            <Row spacing={0} justify="flex-start">
              <Item xs={11} justify="flex-start">
                <MultipleSelect
                  title="Formats"
                  small
                  required
                  options={mediaFormats[activableMedia] || []}
                  placeHolder="Aucun"
                  selected={formats}
                  onChange={values => {
                    handleChange('formats')(values.map(el => el.key));
                  }}
                  disabled={!activableMedia}
                  error={formatsError}
                />
              </Item>
            </Row>
          </Item>
        </Row>
        <Row spacing={0} justify="flex-start">
          <Item xs={6} justify="flex-start">
            <Row spacing={0} justify="flex-start">
              <Item xs={11} justify="flex-start">
                <TextField
                  title="CPM"
                  small
                  required
                  placeholder="Indiquez une valeur de CPM"
                  onChange={handleChange('cpm')}
                  value={cpm}
                  error={cpmError}
                  tooltip="CPM appliqué sur le setup automatique pour le média en question."
                  format="numberDec"
                />
              </Item>
            </Row>
          </Item>
          <Item xs={6} justify="flex-start">
            <Row spacing={0} justify="flex-start">
              <Item xs={11} justify="flex-start">
                <TextField
                  title="CPM mobile"
                  small
                  required
                  placeholder="Indiquez une valeur de CPM"
                  onChange={handleChange('mobileCpm')}
                  value={mobileCpm}
                  error={mobileCpmError}
                  tooltip="CPM appliqué sur le setup automatique de campagnes mobiles pour le média en question."
                  format="numberDec"
                />
              </Item>
            </Row>
          </Item>
        </Row>
        {formatInOtherConfig && (
          <Row spacing={3}>
            <Item>
              <Text align="center">
                L&apos;un de vos formats est déjà lié à une configuration sur ce
                média pour cet espace d&apos;application.
                <br /> Ces nouveaux CPM remplaceront ceux de l&apos;ancienne
                configuration pour ce format et ce média.
              </Text>
            </Item>
          </Row>
        )}
      </FormSection>
    </Modal>
  );
};

export default ModalForm;
